import { render, staticRenderFns } from "./Form.General.vue?vue&type=template&id=b63feee6&scoped=true"
import script from "./Form.General.vue?vue&type=script&lang=js"
export * from "./Form.General.vue?vue&type=script&lang=js"
import style0 from "./Form.General.vue?vue&type=style&index=0&id=b63feee6&prod&scoped=true&lang=css"
import style1 from "./Form.General.vue?vue&type=style&index=1&id=b63feee6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63feee6",
  null
  
)

export default component.exports